/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Partner_Billing_Board_Filtered_Empty_TitleInputs */



/**
* | output |
* | --- |
* | "No partner matches these {count} filters" |
*
* @param {Partner_Billing_Board_Filtered_Empty_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_filtered_empty_title = /** @type {((inputs: Partner_Billing_Board_Filtered_Empty_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Filtered_Empty_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Kein Partner entspricht diesen ${i?.count} Filtern`)
	return /** @type {LocalizedString} */ (`No partner matches these ${i?.count} filters`)
});